"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletApi = exports.ethAddress = void 0;
/**
 * Validate an Ethereum Address for length and ensure that it's stored in lowercase
 * Throws if the provided string is the wrong length or does not start with 0x.
 */
function ethAddress(address) {
    address = address.toLowerCase();
    if (!address.startsWith('0x') || address.length !== 42) {
        throw new Error(`Invalid contract address: ${address}`);
    }
    return address;
}
exports.ethAddress = ethAddress;
/**  */
class WalletApi {
    constructor(data) {
        if (data.address) {
            data.address = ethAddress(data.address);
        }
        let contract;
        for (contract in data.nfts) {
            const lower = ethAddress(contract);
            if (contract !== lower) {
                data.nfts[lower] = data.nfts[contract];
                delete data.nfts[contract];
            }
        }
        this.wallet = data;
    }
    get address() { return ethAddress(this.wallet.address); }
    is(flag) {
        return this.wallet.flags[flag];
    }
    hasToken(tokenContract) {
        return tokenContract in this.wallet.nfts && this.wallet.nfts[tokenContract].tokens.length > 0;
    }
    tokensForContract(tokenContract) {
        var _a;
        return (_a = this.wallet.nfts[tokenContract]) === null || _a === void 0 ? void 0 : _a.tokens;
    }
    allTokens() {
        return this.wallet.nfts;
    }
}
exports.WalletApi = WalletApi;
//# sourceMappingURL=Wallet.js.map